import { useRef, useEffect } from "react";
import LearnMoreBtn from "./LearnMoreBtn";
import { Link } from "react-router-dom";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const FourthDiv = () => {
  let fourthDivRef = useRef(null);

  useEffect(() => {
    gsap.to(fourthDivRef.current, {
      opacity: 1,
      scale: 0.9,
      duration: 1,
      scrollTrigger: {
        trigger: fourthDivRef.current,
        start: "top",
        end: "center",
        toggleActions: "play reverse play reverse",
      },
    });
  });

  return (
    <div className="fourth_div" ref={fourthDivRef}>
      <div className="fourthDiv_left"></div>
      <div className="fourthDiv_right">
        <h2>Crew</h2>
        <Link to="/crewPage">
          <LearnMoreBtn topStyle="58%" leftStyle="50%" />
        </Link>
      </div>
    </div>
  );
};

export default FourthDiv;
